import React, { useState, useEffect, useRef, useCallback } from "react";
import { Grid, List, Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { Formik, Form, validateYupSchema } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/en-gb.js';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import AddProduct from "../../crm/Quotation/AddProduct";
import CreateAttachments from "../../crm/Activities/CreateAttachments";
// import ImageAttachment from "../../biztran_controls/ImageAttachment";




Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};


const CreateCustomerCompaints = (props) => {
    const classes = useStyles();
    //// debugger;
    const [NCNo, setNCNo] = useState("");
    const [Mode, setMode] = useState("");
    const [IssueTicketDate, setIssueTicketDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [RefDate, setRefDate] = useState();
    const [CreatedBy, setCreatedBy] = useState(sessionStorage.UserName);
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState({ id: props.AccountID, AccountName: props.AccountName });
    const [ACAccount, setACAccount] = useState([]);
    const [issueDescription, setissueDescription] = useState("");
    const [ContactNo, setContactNumber] = useState("");
    const [ProductID, setProductID] = useState("");
    const [DrawingNo, setDrawingNo] = useState("");
    const [Qty, setQty] = useState("");
    const [FoundDuring, setFoundDuring] = useState('');
    const [FoundDuringDesc, setFoundDuringDesc] = useState('');
    const [ModelCode, setModelCode] = useState('');
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    // const inputEl = useRef(null);
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    // const [label, setlabel] = useState(false);
    const [isOpen, setOpen] = useState('');
    const [ProductSKUID, setProductSKUID] = useState("");
    const [loading, setLoading] = useState(true);
    const [responsProduct, fetchProductData] = UseFetchData();
    // const [Productcmb, setProductcmb] = useState([]);
    const [ContactNamecmb, setContactNamecmb] = useState([]);
    const [Descritioncmb, setDescritioncmb] = useState([]);
    const [Contactcmb, setContactcmb] = useState([]);
    const [ProductSKUcmb, setProductSKUcmb] = useState([]);
    const [responsContactDtls, fetchContactDtlsData] = UseFetchData();
    const [ContactID, setContactID] = useState("");
    // const [ProductName, setProductName] = useState("");
    const [Description, setDescription] = useState("");
    const [ContactName, setContactName] = useState("");



    const GetContactData = (AccountID) => {
        debugger;
        var bodyFormData = new FormData();
        var acid = "";
        if (AccountID != undefined && AccountID != "") {
            acid = AccountID;
        } else if (AccountName.id != undefined && AccountName.id != "" && AccountName.id != null) {
            acid = AccountName.id
        } else {
            return;
        }
        bodyFormData.append("AccountID", acid);
        fetchContactDtlsData("Quotation/GetCotactDtlsByAccID", bodyFormData);
    };


    const validationSchema = Yup.object({
        AccountID: Yup.string().required("Required!"),
    });


    const FoundDuringOption = [
        { key: "Incoming Inspection", value: "Incoming Inspection" },
        { key: "In-Process Inspection", value: "In-Process Inspection" },
        { key: "Final inspection", value: "Final inspection" },
        { key: "Other", value: "Other" },

    ];

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);


    const handleChange = (e) => {
        onChange && onChange(e);
    };

    const FoundDuringData = () => {
        let FoundDuring = FoundDuringOption.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return FoundDuring;
    };


    const GetProduct = () => {
        debugger;
        setOpen(true);
        setProductID('');
        setProductSKUID('');
        setModelCode('');
        setDescription('');
    }

    const GetProductData = (ProductID) => {
        debugger;
        var bodyFormData = new FormData();
        var acid = "";
        var acSid = "";
        if (ProductSKUID != undefined && ProductSKUID != "" && ProductID != undefined && ProductID != "") {
            acid = ProductID;
            acSid = ProductSKUID;
            bodyFormData.append("ProductID", acid);
            bodyFormData.append("ProductSKUID", acSid);
            fetchProductData("CustomerCompaints/GetProduct", bodyFormData);
        }
    }

    const DescriptionData = React.useCallback((options) => {
        if (options !== undefined) {
            let Product = options.map((data) => (
                <option key={data.Description} value={data.ProductSKUID}>
                    {data.Description}
                </option>
            ));
            setDescritioncmb(Product);
        }
    }, []);

    const ProductSKUData = React.useCallback((options) => {
        if (options !== undefined) {
            let Model = options.map((data) => (
                <option key={data.ModelCode} value={data.ProductSKUID}>
                    {data.ModelCode}
                </option>
            ));
            setProductSKUcmb(Model);
        }
    }, []);


    const ContactData = React.useCallback((options) => {
        debugger;
        if (options !== undefined) {
            let Contact = options.map((data) => (
                <option key={data.Mobile} value={data.ContactID}>
                    {data.Mobile}
                </option>
            ));
            setContactcmb(Contact);
        }
    }, []);

    const ContactNameData = React.useCallback((options) => {
        if (options !== undefined) {
            let ContactN = options.map((data) => (
                <option key={data.ContactName} value={data.ContactID}>
                    {data.ContactName}
                </option>
            ));
            setContactNamecmb(ContactN);
        }
    }, []);


    useEffect(() => {
        debugger;
        if (responsContactDtls !== undefined && responsContactDtls.length > 0) {
            ContactData(responsContactDtls);
            ContactNameData(responsContactDtls);
        } else {
            ContactData([]);
            ContactNameData([]);

        }
    }, [responsContactDtls])

    // const ContactData = (AID) => {
    //     debugger;
    //     var id = "";
    //     if (AID !== "") {
    //         id = AID;
    //     } else if (AccountID !== "") {
    //         id = AccountID;
    //     } else {
    //         id = "";
    //     }
    //     let options = ComboDataResponse["Contact"];
    //     if (options !== undefined) {
    //         if (id !== "") {
    //             let contact = options
    //                 .filter((option) => option.AccountID === id)
    //                 .map((data) => (
    //                     <option key={data.Mobile} value={data.ContactID}>
    //                         {data.Mobile}
    //                     </option>
    //                 ));
    //             setContactcmb(contact);
    //         }
    //         else {
    //             let Contact = options.map((data) => (
    //                 <option key={data.Mobile} value={data.ContactID}>
    //                     {data.Mobile}
    //                 </option>
    //             ));
    //             setContactcmb(Contact);
    //         }
    //     }
    // };

    const onSubmit = () => {
        setMode('Insert');
        var IssueTicketID = "";
        var CreatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        debugger;
        bodyFormData.append("IssueTicketID", props.IssueTicketID);
        bodyFormData.append("IssueTicketNo", NCNo);
        bodyFormData.append("IssueTicketDate", IssueTicketDate);
        bodyFormData.append("AccountID", AccountID);
        bodyFormData.append("ContactID", ContactID);
        bodyFormData.append("CreatedByID", CreatedByID);
        bodyFormData.append("RefNumber", ContactNo);
        bodyFormData.append("RefDate", RefDate);
        bodyFormData.append("ProductSKUID", ProductSKUID);
        // bodyFormData.append("DrawingNumber", DrawingNo);
        // bodyFormData.append("Qty", Qty);
        bodyFormData.append("FoundDuring", FoundDuring);
        bodyFormData.append("FoundDuringDesc", FoundDuringDesc);
        bodyFormData.append("IssueDescription", issueDescription);
        // setLoading(true);
        fetchData("CustomerCompaints/Save", bodyFormData);
    };


    useEffect(() => {
        debugger;
        if (ComboDataResponse['cmbAccount'] !== undefined && ComboDataResponse['cmbAccount'].length > 0) {
            setACAccount(ComboDataResponse['cmbAccount']);
            if (props.IssueTicketID !== '') {
                GetByIDData();
            }
        }
        if (ComboDataResponse["Description"] !== undefined) {
            setLoading(false);
            DescriptionData(ComboDataResponse["Description"]);

        }
        else {
            DescriptionData([]);
        }
        if (ComboDataResponse["ProductSKU"] !== undefined) {
            setLoading(false);
            ProductSKUData(ComboDataResponse["ProductSKU"]);

        }
        else {
            ProductSKUData([]);
        }
        // if (ComboDataResponse["ContactNo"] !== undefined) {
        //     setLoading(false);
        //     ContactData(ComboDataResponse["ContactNo"]);

        // }
        // else {
        //     ContactData([]);
        // }
    }, [ComboDataResponse])




    useEffect(() => {
        debugger;
        if ((response.Response === true) && (Mode === 'Insert')) {
            setLoading(false);
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            setLoading(false);
            alert('Failed.');
        }
        if (props.IssueTicketID !== '') {
            setMode('Update');
        }
        else {
            setMode('Insert');
        }
        if (response.length > 0) {
            setNCNo(response[0].IssueTicketNo);
            setIssueTicketDate((response[0].IssueTicketDate === null) ? "" : Moment(response[0].IssueTicketDate).format('YYYY-MM-DD'));

            setAccountName({ id: response[0].AccountID, List: response[0].AccountName });
            setAccountID((response[0].AccountID === null) ? "" : response[0].AccountID);
            if (response[0].AccountID !== null) {
                GetContactData(response[0].AccountID);
            }
            setContactID((response[0].ContactID === null) ? "" : response[0].ContactID);
            setContactName((response[0].ContactName === null) ? "" : response[0].ContactName)
            setRefDate((response[0].RefDate === null) ? "" : Moment(response[0].RefDate).format('YYYY-MM-DD'));
            // setDrawingNo((response[0].DrawingNumber === null) ? "" : response[0].DrawingNumber);
            setProductSKUID((response[0].ProductSKUID === null) ? "" : response[0].ProductSKUID);
            // setProductID((response[0].ProductID === null) ? "" : response[0].ProductID);
            setDescription((response[0].Description === null) ? "" : response[0].Description)
            setModelCode((response[0].ModelCode === null) ? "" : response[0].ModelCode)
            // setQty((response[0].Qty === null) ? "" : response[0].Qty);
            setFoundDuring((response[0].FoundDuring === null) ? "" : response[0].FoundDuring);
            setFoundDuringDesc(response[0].FoundDuringDesc === null ? "" : response[0].FoundDuringDesc);
            setissueDescription(response[0].IssueDescription === null ? "" : response[0].IssueDescription);
        }
    }, [response]);


    const GetByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("IssueTicketID", props.IssueTicketID);
        fetchData("CustomerCompaints/GetByID", bodyFormData);
    };

    const GetComboData = async () => {
        setLoading(true);
        await fetchComboData("CustomerCompaints/ComboDataCC");
    };

    useEffect(() => {
        GetComboData();
    }, []);

    useEffect(() => {
        if (ProductSKUID != undefined && ProductSKUID != "" && ProductID != undefined && ProductID != "") {
            GetProductData(ProductID, ProductSKUID);
        }
    }, [ProductID, ProductSKUID]);



    const onAccountSelectChange = React.useCallback((e, ACData) => {
        debugger;
        setAccountID(ACData.id);
        setAccountName(ACData);
        GetContactData(ACData.id);
    }, []);



    let Foundduringcmb = FoundDuringData();


    return <div>

        {/* {
      loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 10,
        }}>
          <Loader />
        </div>
      )
    } */}
        <Formik initialValues={{
            NCNo: NCNo, AccountID: AccountID, IssueTicketDate: IssueTicketDate, CreatedBy: CreatedBy, FoundDuring: FoundDuring, RefDate: RefDate, issueDescription: issueDescription, FoundDuringDesc: FoundDuringDesc,
            ProductID: ProductID, ProductSKUID: ProductSKUID, Description: Description, ContactName, ContactName, ContactID: ContactID, Qty: Qty, DrawingNo: DrawingNo, ModelCode: ModelCode
        }}
            validationSchema={validationSchema} enableReinitialize >
            {/* change */}
            {(formik) => {
                return (
                    <Form>
                        {/* <Typography style={{ marginTop: "-16px", marginBottom: "10px" }} className={classes.headertext} noWrap>
                            Quotation Information
                        </Typography> */}
                        <Grid spacing={1} container direction="row">
                            <Grid item xs={2}  >
                                <label
                                    htmlFor={"NCNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"NC No"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="NCNo"
                                    disabled={true}
                                // onChange={(e) => setNCNo(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1} style={{ marginRight: 10 }}>
                                <label
                                    htmlFor={"IssueTicketDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                    type="IssueTicketDate"
                                >
                                    {"Date"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="date"
                                    name="IssueTicketDate"
                                    // disabled={true}
                                    onChange={(e) => setIssueTicketDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1.5} style={{ marginRight: 65 }}>
                                <label
                                    htmlFor={"CreatedBy"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Created By"}
                                </label>
                            </Grid>
                            <Grid item xs={2} >
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="CreatedBy"
                                    disabled={true}
                                    onChange={(e) => setCreatedBy(e.target.value)}
                                />
                            </Grid>
                            {/* <Grid item xs={1} >
                            </Grid> */}
                            <Grid item xs={2} style={{ marginRight: 2 }}>
                                <label htmlFor={"AccountID"}
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                    }}>
                                    {"Customer"}
                                </label>
                            </Grid>
                            <Grid item xs={9} style={{ marginRight: 2 }}>
                                <BiztranControls.Autocomplete
                                    options={ACAccount}
                                    onChange={onAccountSelectChange}
                                    value={AccountName}
                                    name="AccountID"
                                />
                            </Grid>

                            <Grid item xs={2}  >
                                <label
                                    htmlFor={"ContactName"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Contact"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="select"
                                    name="ContactID"
                                    options={ContactNamecmb}
                                    value={ContactID}
                                    onChange={(e) => setContactID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1.5} style={{ marginRight: 2 }}>
                                <label
                                    htmlFor={"ContactNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Contact No"}
                                </label>
                            </Grid>
                            <Grid item xs={2} >
                                {/* <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="ContactNo"
                                    // disabled={true}
                                    ref={ref}
                                    value={ContactNo}
                                    onChange={(e) => {
                                        setContactNumber(e.target.value)
                                        handleChange()
                                    }}
                                /> */}
                                <BiztranControlsFormik
                                    control="select"
                                    name="ContactID"
                                    options={Contactcmb}
                                    value={ContactID}
                                    onChange={(e) => setContactID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1} style={{ marginRight: 70 }}>
                                <label
                                    htmlFor={"RefDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Ref Date"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="date"
                                    name="RefDate"
                                    // defaultValue={ValidUpTo}
                                    onChange={(e) => setRefDate(e.target.value)}
                                />
                            </Grid>
                            {/* <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2}>
                            </Grid> */}

                            <Grid item xs={2} style={{ marginRight: 2 }}>
                                <label
                                    htmlFor={"ModelCode"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"ModelCode"}
                                </label>
                            </Grid>
                            <Grid item xs={3} >
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="ModelCode"
                                    value={ModelCode}
                                    disabled={true}
                                // onChange={(e) => setModelCode(e.target.value)}
                                />
                                {/* <BiztranControlsFormik
                                    control="select"
                                    name="ProductSKUID"
                                    options={ProductSKUcmb}
                                    disabled={true}
                                // onChange={onSelectChange}
                                /> */}
                            </Grid>
                            <Grid item xs={1} style={{ marginTop: -10 }} >
                                <BiztranControls.Button
                                    text="..."
                                    style={{ fontSize: 10 }}
                                    onClick={() => {
                                        GetProduct();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                                <label
                                    htmlFor={"ProductID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Description"}
                                </label>
                            </Grid>
                            <Grid item xs={9} >
                                {/* <BiztranControlsFormik
                                    control="select"
                                    name="ProductSKUID"
                                    options={Descritioncmb}
                                    disabled={true}
                                // onChange={onSelectChange}
                                /> */}
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Description"
                                    value={Description}
                                    disabled={true}
                                // onChange={(e) => setModelCode(e.target.value)}
                                />
                            </Grid>
                            {/* <Grid item xs={2} >
                                <label
                                    htmlFor={"DrawingNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Drawing No"}
                                </label>
                            </Grid> */}
                            {/* <Grid item xs={2} >
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="DrawingNo"
                                    ref={ref}
                                    value={DrawingNo}
                                    // disabled={true}
                                    onChange={(e) => {
                                        setDrawingNo(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid> */}
                            {/* <Grid item xs={1}>
                                <label
                                    htmlFor={"Qty"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Qty"}
                                </label>
                            </Grid> */}
                            {/* <Grid item xs={2} >
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Qty"
                                    ref={ref}
                                    value={Qty}
                                    onChange={(e) => {
                                        setQty(e.target.value)
                                        handleChange()
                                    }}
                                // disabled={true}
                                />
                            </Grid> */}
                            {/* <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={3}>
                            </Grid> */}
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"FoundDuring"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Found During"}
                                </label>
                            </Grid>
                            <Grid item xs={2}>
                                <BiztranControlsFormik
                                    control="select"
                                    options={Foundduringcmb}
                                    name="FoundDuring"
                                    // value={QuotationStage}
                                    onChange={(e) => setFoundDuring(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1} style={{ marginRight: 2 }}>
                                <label
                                    htmlFor={"FoundDuringDesc"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Description"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="FoundDuringDesc"
                                    // disabled={true}
                                    ref={ref}
                                    value={FoundDuringDesc}
                                    onChange={(e) => {
                                        setFoundDuringDesc(e.target.value)
                                        handleChange()
                                    }}
                                />
                            </Grid>

                            <Grid item xs={2} >
                                <label
                                    htmlFor={"issue Description"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Issue Description"}
                                </label>
                            </Grid>
                            <Grid item xs={9} >
                                <BiztranControlsFormik
                                    control="textarea"
                                    type="text"
                                    name="issueDescription"
                                    ref={ref}
                                    value={issueDescription}
                                    // disabled={true}
                                    onChange={(e) => {
                                        setissueDescription(e.target.value)
                                        handleChange()
                                    }}
                                // disabled={true}
                                />
                            </Grid>
                            <Grid item xs={2} >
                                <label
                                    htmlFor={"Attachment"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Attachment"}
                                </label>
                            </Grid>
                            <Grid item xs={7}  >
                                {/* <ImageAttachment
                                    id="CustomerCompaints-img-btn"
                                    Group="CustomerCompaints"
                                    Type="Image"
                                    RefDocumentID={props.IssueTicketID}
                                /> */}
                                <Paper style={{ height: 200 }} elevation={3}>
                                    <CreateAttachments
                                        RefDocumentID={props.IssueTicketID}
                                        Group="CustomerCompaints"
                                        CustomerCompaintsAttachData={props.CustomerCompaintsAttachData}
                                    />
                                </Paper>
                            </Grid>
                            <Grid item xs={1}></Grid>
                            {/* <Grid item xs={2} style={{ marginLeft: '60px' }} >
                                <ImageAttachment
                                    id="CustomerCompaints1-img-btn"
                                    Group="CustomerCompaints1"
                                    Type="Image"
                                    RefDocumentID={props.IssueTicketID}
                                />
                            </Grid> */}
                            <Grid item xs={1} ></Grid>

                        </Grid>
                        <Grid spacing={1} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                        }}
                                    >
                                        < BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            onClick={() => {
                                                onSubmit();
                                            }}
                                            startIcon={<SaveIcon />}
                                        />
                                        < BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {
                                                props.setOpen(false);
                                            }}
                                        />

                                        <ModalFrame
                                            title="Add Product"
                                            maxWidth="lg"
                                            isOpen={isOpen}
                                            headerAlign="center"
                                            setOpen={setOpen}
                                        >
                                            <AddProduct
                                                ProductSKUID={ProductSKUID}
                                                setOpen={setOpen}
                                                pageName={"NCR"}
                                                // PopulateData={GetProductData}
                                                setProductID={setProductID}
                                                setProductSKUID={setProductSKUID}
                                                setModelCode={setModelCode}
                                                setDescription={setDescription}
                                            />
                                        </ModalFrame>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                )
            }}
        </Formik>
    </div>
}

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        marginLeft: "-24px",
        marginRight: "-24px",
    },
}));

export default CreateCustomerCompaints;
